<template>
  <li
    :to="to"
    :class="[
      {'step--current' : isActive},
      {'step--disabled': !isActive && !isClickable}
    ]"
    class="color-white step bg-color-secondary color-white font-xs"
    @click="go"
  >
    <span class="bubble text-center">
      <slot>
        {{ number }}
      </slot>
    </span>
  </li>
</template>
<script>
export default {
  props: {
    to: {
      required: true,
      type: String,
    },
    done: {
      required: true,
      type: Number,
    },
    form: {
      required: true,
      type: Object,
    },
    number: {
      required: true,
      type: [String, Number],
    },
  },
  computed: {
    isActive() {
      return this.done >= this.number;
    },
    isClickable() {
      return this.form[`step${this.number - 1}`];
    },
  },
  methods: {
    go() {
      if (this.isActive || this.isClickable) {
        this.$router.push(this.to);
      }
    },
  },
};
</script>
